var map = {
	"./about.svg": "78ed",
	"./accounts.svg": "76e0",
	"./admins.svg": "a3aa",
	"./angle.svg": "492b",
	"./appl.svg": "5250",
	"./apple.svg": "8642",
	"./arrows.svg": "4509",
	"./avatar-placeholder.svg": "cc6e",
	"./back-arrow.svg": "bb06",
	"./back.svg": "90f1",
	"./bottom-arrow.svg": "525f",
	"./buttonMenu.svg": "57c0",
	"./calendar-2.svg": "0687",
	"./calendar.svg": "dc29",
	"./call.svg": "2c28",
	"./camera.svg": "0ca2",
	"./checkmark.svg": "6405",
	"./chevron-left.svg": "f1a4",
	"./chevron-right.svg": "1ca1",
	"./chevron.svg": "c963",
	"./clock.svg": "1458",
	"./close.svg": "d866",
	"./copy.svg": "0490",
	"./credits.svg": "21a2",
	"./dashboard.svg": "f6c2",
	"./desktop.svg": "d6a3",
	"./devices.svg": "63a2",
	"./esim.svg": "b2e1",
	"./esimPayment.svg": "f600",
	"./faq.svg": "6a84",
	"./fax.svg": "c913",
	"./fb.svg": "e945",
	"./file.svg": "1589",
	"./filter-fill.svg": "e7c5",
	"./filter.svg": "7ac1",
	"./hamburger.svg": "296a",
	"./hold-users.svg": "aea6",
	"./inbound.svg": "9483",
	"./inst.svg": "64d0",
	"./landline.svg": "8e82",
	"./left-angle.svg": "1b21",
	"./line.svg": "c5e7",
	"./locations.svg": "be9e",
	"./logout.svg": "090a",
	"./manual.svg": "19f9",
	"./message-arrow.svg": "6f37",
	"./missed.svg": "f6c7",
	"./mms.svg": "3c5f",
	"./msg.svg": "2a77",
	"./notes.svg": "1ee2",
	"./notification-center.svg": "efa6",
	"./notifications.svg": "3580",
	"./onHold.svg": "4d44",
	"./operators.svg": "6e0c",
	"./outbound.svg": "14dd",
	"./package.svg": "8b75",
	"./packages.svg": "f551",
	"./pause.svg": "16b2",
	"./payments.svg": "ad59",
	"./pen.svg": "9a69",
	"./phone.svg": "fe08",
	"./plus.svg": "521e",
	"./progress.svg": "c354",
	"./promo.svg": "cb1c",
	"./qr.svg": "e8ec",
	"./reload.svg": "edc7",
	"./remove.svg": "6797",
	"./search.svg": "e96c",
	"./secure-human.svg": "8e41",
	"./send.svg": "67e3",
	"./settings.svg": "8462",
	"./sms.svg": "f83c",
	"./sms2.svg": "fd55",
	"./stop.svg": "2a42",
	"./success.svg": "6b09",
	"./templates.svg": "52d1",
	"./tick.svg": "5e15",
	"./top-arrow.svg": "6390",
	"./trash.svg": "3564",
	"./warn.svg": "35cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "957c";